module.exports = __webpack_public_path__ + "static/features-ee87087fc675bedd24ab3735870efb36.webp";